import { reportTypes as oldReports } from 'app/common/api/requests/reports/perform'
import { ReportType } from 'app/dataTypes/reports'

import { dataKey as accountingDataKey } from './_Accounting/dataKey'
import { dataKey as balanceDataKey } from './_Balance/dataKey'
import { dataKey as salesDataKey } from './_Sales/dataKey'
import { dataKey as salesByFundsDataKey } from './_SalesByFunds/dataKey'
import { dataKey as subsidiesDataKey } from './_Subsidies/dataKey'
import { dataKey as salesByGroupComplexesDataKey } from './_SalesByGroupComplexes/dataKey'
import { dataKey as purchasesByPaymentModeDataKey } from './_PurchasesByPaymentMode/dataKey'
import { dataKey as correctionsDataKey } from './_Corrections/dataKey'
import { dataKey as ordersByClassesDataKey } from './_OrdersByClasses/dataKey'

import { getSubReports as getSubsidiesSubReports } from './_Subsidies/getSubReports'

const reports: Map<string, { key: string; title: string; description: string }> = new Map([
  [
    accountingDataKey,
    {
      key: accountingDataKey,
      title: 'Учет выдачи',
      description:
        'В отчете «Учет выдачи» можно посмотреть информацию по количеству и сумме выданной продукции с применением различных фильтров и за любой период времени. Доступна информация о непроведенных заявках сотрудниками заведений. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
  [
    balanceDataKey,
    {
      key: balanceDataKey,
      title: 'Остаток средств',
      description:
        'В отчете «Остаток средств» можно посмотреть состояние лицевых счетов пользователей как на текущий момент, так и на момент любой даты с предыдущих дней с применением различных фильтров. Доступно несколько видов группировок информации. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
  [
    salesDataKey,
    {
      key: salesDataKey,
      title: 'Продажи',
      description:
        'В отчете «Продажи» можно посмотреть информацию по всем видам продаж с применением различных фильтров и за любой период времени. Доступно несколько видов группировок информации. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
  [
    salesByGroupComplexesDataKey,
    {
      key: salesByGroupComplexesDataKey,
      title: 'Продажи по виду продукции',
      description:
        'В отчете «Продажи по виду продукции» можно посмотреть информацию по продажам типа «Комплексное питание» с применением различных фильтров и за любой период времени. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
  [
    salesByFundsDataKey,
    {
      key: salesByFundsDataKey,
      title: 'Продажи по видам средств',
      description:
        'В отчете «Продажи по видам средств» можно посмотреть информацию для формирования группового талона, с разбивкой сумм продаж на родительские и бюджетные средства. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
  [
    subsidiesDataKey,
    {
      key: subsidiesDataKey,
      title: 'Дотации',
      description:
        'В отчете «Дотации» можно посмотреть информацию по льготному питанию с применением различных фильтров и за любой период времени. Доступно несколько видов группировок информации. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
  [
    purchasesByPaymentModeDataKey,
    {
      key: purchasesByPaymentModeDataKey,
      title: 'Продажи по способу расчета',
      description:
        'В отчете «Продажи по способу расчета» можно посмотреть продажи по каждому способу расчета: “Внутренний счет”, “Наличные” и “Банковская карта”. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
  [
    correctionsDataKey,
    {
      key: correctionsDataKey,
      title: 'Корректировки',
      description:
        'В отчете «Корректировки» можно посмотреть изменения по продажам и дотациям, сделанные задним числом. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
  [
    ordersByClassesDataKey,
    {
      key: ordersByClassesDataKey,
      title: 'Учет количества питающихся',
      description:
        'В отчете «Учет количества питающихся» можно посмотреть количество питающихся с разбивкой по сменам и режимам питания. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
  [
    ReportType.FinancesSummary as string,
    {
      key: ReportType.FinancesSummary,
      title: 'Финансы',
      description:
        'В отчете «Финансы» можно посмотреть информацию по финансам пользователей: остаток средств на начало периода, сумма пополнений, сумма списаний и баланс на конец периода.',
    },
  ],
  [
    ReportType.AverageCheck as string,
    {
      key: ReportType.AverageCheck,
      title: 'Средний чек',
      description:
        'Отчет показывает среднюю сумму одной покупки. Рассчитывается как отношение общей выручки к количеству продаж за выбранный период. Имеется возможность выгрузить результат в файл в формате excel.',
    },
  ],
])

export const reportsArrange: Array<string> = [
  balanceDataKey,
  subsidiesDataKey,
  salesDataKey,
  salesByGroupComplexesDataKey,
  accountingDataKey,
  salesByFundsDataKey,
  purchasesByPaymentModeDataKey,
  correctionsDataKey,
  ordersByClassesDataKey,
  ReportType.FinancesSummary,
  ReportType.AverageCheck,
]

export const getReportTitle = (report: string): string => {
  const reportInfo = reports.get(report)
  return reportInfo ? reportInfo.title : 'Неизвестный'
}

export const getReportDescription = (report: string): string => {
  const reportInfo = reports.get(report)
  return reportInfo ? reportInfo.description : '…'
}

const titles = {}

reports.forEach(({ title }, key) => {
  titles[key] = title
})

export const getReportTitlesAll = () => titles

export const getSubReportsInReport = (report: string): Array<string> => {
  if (report === accountingDataKey) {
    return [oldReports.REPORT_ACCOUNTING_CUSTOMERS]
  }
  if (report === balanceDataKey) {
    return [oldReports.REPORT_BALANCES]
  }
  if (report === salesDataKey) {
    return [oldReports.REPORT_PURCHASES]
  }
  if (report === salesByGroupComplexesDataKey) {
    return [oldReports.REPORT_PURCHASES_BY_GROUP_COMPLEXES_2]
  }
  if (report === salesByFundsDataKey) {
    return [oldReports.REPORT_PURCHASES_BY_FUNDS]
  }
  if (report === purchasesByPaymentModeDataKey) {
    return [oldReports.REPORT_PURCHASES_BY_PAYMENT_MODE]
  }
  if (report === correctionsDataKey) {
    return [correctionsDataKey]
  }
  if (report === ordersByClassesDataKey) {
    return [ordersByClassesDataKey]
  }
  if (report === subsidiesDataKey) {
    return getSubsidiesSubReports()
  }
  if (report === ReportType.FinancesSummary) {
    return [
      ReportType.FinancesSummary,
      ReportType.FinancesSummaryReplenishment,
      ReportType.FinancesSummaryWriteOff,
    ]
  }
  if (report === ReportType.AverageCheck) {
    return [ReportType.AverageCheck]
  }
  return []
}

export const getSubReportsInReportTitles = (report: string): Array<string> => {
  if (report === subsidiesDataKey) {
    return ['Детализированный', 'Сгруппированный', 'Акт']
  }
  if (report === ReportType.FinancesSummary) {
    return ['Общий', 'Пополнения', 'Списания']
  }
  return []
}
